var map = {
	"./AI_TWIN/AI_TWIN_DEMO_1_character.png": 7278,
	"./AI_TWIN/AI_TWIN_DEMO_2_bubble_1.png": 6020,
	"./AI_TWIN/AI_TWIN_DEMO_2_bubble_2.png": 6863,
	"./AI_TWIN/AI_TWIN_DEMO_2_bubble_3.png": 7846,
	"./AI_TWIN/AI_TWIN_DEMO_3_bubble_1.png": 8159,
	"./AI_TWIN/AI_TWIN_DEMO_3_bubble_2.png": 3508,
	"./AI_TWIN/AI_TWIN_DEMO_3_bubble_3.png": 3453,
	"./AI_TWIN/AI_TWIN_DEMO_3_bubble_4.png": 946,
	"./AI_TWIN/AI_TWIN_DEMO_3_checkmark.png": 6414,
	"./AI_TWIN/AI_TWIN_DEMO_3_computer.png": 6850,
	"./AI_TWIN/AI_TWIN_DEMO_4_bell.png": 4611,
	"./AI_TWIN/AI_TWIN_DEMO_4_bubble_1.png": 2522,
	"./AI_TWIN/AI_TWIN_DEMO_4_bubble_2.png": 8769,
	"./AI_TWIN/AI_TWIN_DEMO_4_bubble_3.png": 376,
	"./AI_TWIN/AI_TWIN_DEMO_4_bubble_4.png": 9991,
	"./AI_TWIN/AI_TWIN_DEMO_4_bubble_5.png": 4206,
	"./AI_TWIN/AI_TWIN_DEMO_4_computer.png": 8867,
	"./AI_TWIN/AI_TWIN_DEMO_5_bubble_1.png": 557,
	"./AI_TWIN/AI_TWIN_DEMO_5_bubble_2.png": 8934,
	"./AI_TWIN/AI_TWIN_DEMO_5_bubble_3.png": 5263,
	"./AI_TWIN/AI_TWIN_DEMO_5_computer.png": 1452,
	"./AI_TWIN/AI_TWIN_DEMO_5_eye.png": 3920,
	"./AI_TWIN/AI_TWIN_DEMO_6_bubble_1.png": 8080,
	"./AI_TWIN/AI_TWIN_DEMO_6_bubble_2.png": 1579,
	"./AI_TWIN/AI_TWIN_DEMO_6_bubble_3.png": 450,
	"./AI_TWIN/AI_TWIN_DEMO_6_bubble_4.png": 6797,
	"./AI_TWIN/AI_TWIN_DEMO_computer.png": 2428,
	"./AI_TWIN/AI_Twin_01.png": 6830,
	"./AI_TWIN/AI_Twin_02.png": 7829,
	"./AI_TWIN/AI_Twin_03.png": 8732,
	"./AI_TWIN/AI_Twin_04.png": 8899,
	"./AI_TWIN/AI_Twin_05.png": 7674,
	"./AI_TWIN/AI_Twin_06.png": 1489,
	"./AI_TWIN/character_5.png": 1976,
	"./DNA1/DNA1_DOW_DEMO_01_CHARACTER.png": 3311,
	"./DNA1/DNA1_DOW_DEMO_02_Board.png": 3761,
	"./DNA1/DNA1_DOW_DEMO_02_PopUp.png": 1499,
	"./DNA1/DNA1_DOW_DEMO_03_Computer.png": 6049,
	"./DNA1/DNA1_DOW_DEMO_03_PopUp_1.png": 6474,
	"./DNA1/DNA1_DOW_DEMO_03_PopUp_2.png": 3905,
	"./DNA1/DNA1_DOW_DEMO_04_Computer.png": 6580,
	"./DNA1/DNA1_DOW_DEMO_04_PopUp_1.png": 3169,
	"./DNA1/DNA1_DOW_DEMO_04_PopUp_2.png": 6922,
	"./DNA1/DNA1_DOW_DEMO_05_Computer.png": 4731,
	"./DNA1/DNA1_DOW_DEMO_05_PopUp_1.png": 3180,
	"./DNA1/DNA1_DOW_DEMO_05_PopUp_2.png": 7463,
	"./DNA1/DNA1_DOW_DEMO_06_CHARACTER.png": 1564,
	"./DNA1/DNA1_DOW_DEMO_07_Computer.png": 1173,
	"./DNA1/DNA1_DOW_DEMO_07_PopUp_1.png": 646,
	"./DNA1/DNA1_DOW_DEMO_07_PopUp_2.png": 2413,
	"./DNA1/DNA1_DOW_DEMO_07_PopUp_3.png": 9172,
	"./DNA1/DNA1_DOW_DEMO_Video_bg.png": 4555,
	"./DNA1/DNA1_INTRO_1_Cycle.png": 4668,
	"./DNA1/DNA1_demo_1_name.png": 6624,
	"./DNA1/DNA1_demo_2_name.png": 1985,
	"./DNA1/DNA1_intro_01.jpg": 4549,
	"./DNA1/DNA1_intro_02.jpg": 1946,
	"./DNA1/DNA1_intro_03.jpg": 6407,
	"./DNA1/DNA1_intro_04.jpg": 2060,
	"./DNA1/DNA1_intro_04.png": 7208,
	"./DNA2/DNA2_DOW_DEMO_01_CHARACTER.png": 7249,
	"./DNA2/DNA2_DS_DEMO_02_bubble_1.png": 122,
	"./DNA2/DNA2_DS_DEMO_02_bubble_2.png": 9105,
	"./DNA2/DNA2_DS_DEMO_02_bubble_3.png": 4488,
	"./DNA2/DNA2_DS_DEMO_02_computer.png": 7699,
	"./DNA2/DNA2_DS_DEMO_02_list.png": 2416,
	"./DNA2/DNA2_DS_DEMO_03_alert.png": 9541,
	"./DNA2/DNA2_DS_DEMO_03_check.png": 5015,
	"./DNA2/DNA2_DS_DEMO_03_computer.png": 2028,
	"./DNA2/DNA2_DS_DEMO_03_eye.png": 9328,
	"./DNA2/DNA2_DS_DEMO_04_check.png": 6616,
	"./DNA2/DNA2_DS_DEMO_04_computer.png": 2681,
	"./DNA2/DNA2_DS_DEMO_04_eye.png": 4755,
	"./DNA2/DNA2_DS_DEMO_04_screen.png": 3994,
	"./DNA2/DNA2_DS_DEMO_05_bubble_1.png": 9631,
	"./DNA2/DNA2_DS_DEMO_05_bubble_2.png": 724,
	"./DNA2/DNA2_DS_DEMO_05_bubble_3.png": 1853,
	"./DNA2/DNA2_DS_DEMO_05_computer.png": 6354,
	"./DNA2/DNA2_DS_DEMO_06_bubble_1.png": 2270,
	"./DNA2/DNA2_DS_DEMO_06_bubble_2.png": 101,
	"./DNA2/DNA2_DS_DEMO_06_computer.png": 1087,
	"./DNA2/DNA2_DS_DEMO_07_Character.png": 2334,
	"./DNA2/DNA2_DS_DEMO_08_bubble_accuracy.png": 4214,
	"./DNA2/DNA2_DS_DEMO_08_bubble_automation.png": 1532,
	"./DNA2/DNA2_DS_DEMO_08_bubble_innovation.png": 5512,
	"./DNA2/DNA2_DS_DEMO_08_bubble_speed.png": 6828,
	"./DNA2/DNA2_DS_DEMO_08_computer.png": 4357,
	"./DNA2/DNA2_DS_DEMO_08_screen.png": 1334,
	"./DNA2/DNA2_DS_DEMO_09_bubble.png": 767,
	"./DNA2/DNA2_DS_DEMO_09_computer.png": 7214,
	"./DNA2/DNA2_DS_DEMO_09_screen.png": 1057,
	"./DNA2/DNA2_demo1_name.png": 8627,
	"./DNA2/DNA2_demo2_name.png": 4038,
	"./DNA2/DNA2_intro_01.jpg": 3971,
	"./DNA2/DNA2_intro_02.jpg": 7908,
	"./DNA2/DNA2_intro_03.jpg": 2241,
	"./DNA2/DNA2_intro_04.jpg": 3986,
	"./EV/EV_demo_Intro_01.png": 743,
	"./EV/EV_demo_Intro_02.png": 2012,
	"./EV/EV_demo_Intro_03.png": 9525,
	"./EV/EV_demo_Intro_04.png": 1210,
	"./EV/EV_demo_Intro_05.png": 1971,
	"./EV/EV_demo_Intro_06.png": 1128,
	"./EV/EV_demo_Intro_07.png": 193,
	"./EV/EV_demo_Intro_08.png": 1657,
	"./EV/EV_demo_Intro_09.png": 9135,
	"./EV/EV_demo_end_QR.png": 4564,
	"./EV/EV_demo_use_case_01.png": 5341,
	"./EV/EV_demo_use_case_02.png": 4134,
	"./EV/EV_demo_use_case_03.png": 3151,
	"./EV/EV_demo_use_case_04.png": 928,
	"./EV/EV_demo_use_case_05.png": 7177,
	"./EV/EV_intro_QR.png": 1139,
	"./EV/EV_intro_cycle.png": 1782,
	"./EV/EV_intro_logo.png": 491,
	"./EV/EV_intro_logo_2.png": 1404,
	"./EV/EV_use_cases_right_image.png": 8021,
	"./EV/UseCase_1.png": 1566,
	"./EV/UseCase_3.png": 7132,
	"./EV/UseCase_4.png": 4531,
	"./EV/UseCase_5.png": 8970,
	"./EdgeverveLogo.png": 9839,
	"./InfosysTopazLogo.png": 8499,
	"./characters/character_1.png": 4971,
	"./characters/character_2.png": 6640,
	"./characters/character_3.png": 7817,
	"./characters/character_4.png": 1638,
	"./characters/character_5.png": 7967,
	"./characters/character_dna1_1.gif": 2195,
	"./characters/character_dna1_2.gif": 7948,
	"./characters/character_dna2_1.gif": 6400,
	"./characters/character_dna2_2.gif": 7063,
	"./icons_labels/start.png": 3518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8803;